import {
  transformAEMData,
  sendCustomLog,
} from '@profile-ui/shared-components';
import processContentFallback from './processContentFallback';
import { MAXIMUM_NUMBER_OF_ENTITIES } from '../constants';

/**
 * Fetches and transforms AEM content for a given locale.
 * @param {string} isoLocale - The ISO locale to fetch content for
 * @returns {Promise<{isoLocale: string, aemContents: object}>} - The ISO locale and transformed AEM contents
 */
const fetchAEMContent = async (isoLocale) => {
  sendCustomLog('LocaleProvider', `Fetching content for locale, ${isoLocale}`);

  let rawAEMData;
  try {
    rawAEMData = await window.cfp.providers.content.get('userprofile', {
      locale: isoLocale,
      limit: MAXIMUM_NUMBER_OF_ENTITIES,
    });
    sendCustomLog(
      'LocaleProvider',
      `Successfully fetched content from AEM for locale, ${isoLocale}`
    );
  } catch (error) {
    rawAEMData = await processContentFallback(isoLocale);
  }

  const aemContents = transformAEMData(rawAEMData);

  return aemContents;
};

export default fetchAEMContent;
